import { RichUtils } from "draft-js";
import { getAtomicEntityInfo } from "lib/helpers";
import { InsertHrButton } from "./InsertHrButton";
import { createToolbarButtons } from "../createToolbarButtons";
import { insertHrAtomic } from "./modifier/insertHrAtomic";
import { HrBlock } from "./components/HrBlock";


const defaultOptions = {
	buttons: ['hr', 'spliter'],
};

const BUTTON_MAP = {
	hr: InsertHrButton,
}

/**
 * @returns {DraftEditorPlugin}
 */
export function createHrPlugin(options = defaultOptions) {
	const { buttons } = options;
	return {
		getToolbarButtons(props) {
			if (props.env !== 'root') {
				return null;
			}
			const editorState = props.store.getEditorState();
			// 代码块不支持图片
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return null;
			}
			return createToolbarButtons(BUTTON_MAP, buttons, {
				...props,
				onInsert: () => insertHrAtomic(props.store),
			});
		},

		getBlockRenderInfo(block, store) {
			const entityInfo = getAtomicEntityInfo(block, store);
			if (entityInfo && entityInfo.entityType === 'HR') {
				return {
					component: HrBlock,
					editable: false,
					props: {
						...entityInfo,
						store,
					},
				};
			}
		},
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/hrPlugin/createHrPlugin.js